const React = require('react')
import {
  Button,
  Col,
  Modal,
  Row
} from 'react-bootstrap'

class GenericError extends React.Component {
  render() {
    return (
      <Row>
        <Col md={6} sm={6} mdOffset={3} smOffset={3} style={{textAlign: 'center'}}>
          <h3 className="frog-font">Woops! An error occurred</h3>
          <p>Please restart this app or try again later.</p>
        </Col>
      </Row>
    )
  }
}

class GenericErrorModal extends React.Component {
  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onClose}>
        <Modal.Body>
          <h3 className="frog-font">An error occurred</h3>
          <p>Please restart this app or try again later.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onClose}>OK</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export {
  GenericError,
  GenericErrorModal
}



